// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27Tmx","label":"styles_label__3b1mS"};